<template>
  <div class="mt-4 p-3 border rounded-4 bg-light">
    <h4 class="mb-3">Configuración Revo</h4>
    <div class="mb-3">
      <label for="token" class="form-label">Token:<span class="text-danger">*</span></label>
      <input
        id="token"
        type="text"
        class="form-control"
        v-model="localToken"
        @input="onTokenChange"
        maxlength="200"
        placeholder="" />
    </div>
    <div class="mb-3">
      <label for="accountUsername" class="form-label">Account Username:<span class="text-danger">*</span></label>
      <input
        id="accountUsername"
        type="text"
        class="form-control"
        v-model="localAccountUsername"
        @input="onAccountUsernameChange"
        maxlength="100"
        placeholder="" />
    </div>
    <div class="mb-3">
      <label for="clientToken" class="form-label">Client Token:<span class="text-danger">*</span></label>
      <input
        id="clientToken"
        type="text"
        class="form-control"
        v-model="localClientToken"
        @input="onClientTokenChange"
        maxlength="200"
        placeholder="" />
    </div>
  </div>
</template>

<script>
export default {
  name: 'FormRevoComponent',
  props: {
    token: { type: String, default: '' },
    accountUsername: { type: String, default: '' },
    clientToken: { type: String, default: '' }
  },
  data() {
    return {
      localToken: this.token,
      localAccountUsername: this.accountUsername,
      localClientToken: this.clientToken
    };
  },
  watch: {
    token(val) {
      this.localToken = val;
    },
    accountUsername(val) {
      this.localAccountUsername = val;
    },
    clientToken(val) {
      this.localClientToken = val;
    }
  },
  methods: {
    onTokenChange() {
      this.$emit('update:token', this.localToken);
    },
    onAccountUsernameChange() {
      this.$emit('update:accountUsername', this.localAccountUsername);
    },
    onClientTokenChange() {
      this.$emit('update:clientToken', this.localClientToken);
    }
  }
};
</script>

<style scoped>

</style>
